import axios, { type AxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';
import _ from 'lodash';

export const SHOP_REDIRECT_AFTER_LOGIN_KEY = 'redirect_after_login_shop';

const TIMEOUT = 1 * 30 * 1000;
const isServer = typeof window === 'undefined';
axios.defaults.timeout = TIMEOUT;
const isDev = process.env.NODE_ENV !== 'production';

export const TOKEN_KEY = 'shop-token';

const tokenFunction = (req: any) => {
  if (isServer) {
    const cookies = _.get(req, 'headers.cookie', '');

    const jwtCookie =
      cookies
        .split(';')
        .map((x: any) => x.trim())
        .find((x: any) => _.startsWith(x, `${TOKEN_KEY}=`)) || '';

    return jwtCookie.replace(`${TOKEN_KEY}=`, '');
  }
  return Cookies.get(TOKEN_KEY);
};

export const getToken = tokenFunction;

const getBaseUrl = () => {
  if (isServer) {
    if (isDev) {
      return 'http://127.0.0.1:3001/api';
    }
    return 'http://end-customer-gateway:9090/api';
  }
  return '/api';
};

export const getAxiosInstanceWithoutErrorChecking = (request: any) => {
  const token = getToken(request);
  const baseUrl = getBaseUrl();
  const headers = {} as { [key: string]: string };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  const instance = axios.create({
    baseURL: baseUrl,
    headers,
  });

  if (isServer) {
    instance.defaults.headers.common['x-flaivy-host'] = request.headers.host;
  } else {
    const url = window.location.href;
    const hostName = url.split('/')[2];
    instance.defaults.headers.common['x-flaivy-host'] = hostName;
  }
  return instance;
};

const getAxiosInstance = (request?: AxiosRequestConfig) => {
  const onResponseSuccess = (response: any) => response;

  const onResponseError = (err: any) => {
    const status = err && (err.status || (err.response && err.response.status));
    if (axios.isCancel(err)) {
      return Promise.reject(err);
    }
    if (status === 401) {
      Cookies.set(
        SHOP_REDIRECT_AFTER_LOGIN_KEY,
        // @ts-ignore
        _.get(request, 'url', _.get(window, 'location')),
        {
          httpOnly: false, // true by default
        },
      );
      // @ts-ignore
      window.location = '/';
    } else if (status === 503) {
      if (!isDev) {
        // @ts-ignore
        window.location = '/maintenance';
      }
    }
    return Promise.reject(err);
  };
  const headers: { [key: string]: string } = {};

  const token = getToken(request);
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const baseUrl = getBaseUrl();
  const instance = axios.create({
    baseURL: baseUrl,
    headers,
  });

  if (isServer) {
    instance.defaults.headers.common['x-flaivy-host'] = request?.headers?.host;
  } else {
    const url = window.location.href;
    const hostName = url.split('/')[2];
    instance.defaults.headers.common['x-flaivy-host'] = hostName;
    instance.interceptors.response.use(onResponseSuccess, onResponseError);
  }
  return instance;
};

export default getAxiosInstance;
